import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { translations } from '@/i18n/translations';

const LanguageContext = createContext({ language: 'it', t: (text) => text });
const detectLanguage = () => typeof navigator !== 'undefined' && navigator.language.toLowerCase().startsWith('en') ? 'en' : 'it';

export default function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(detectLanguage);

  useEffect(() => {
    const updateLanguage = () => setLanguage(detectLanguage());
    document.documentElement.lang = language;
    window.addEventListener('languagechange', updateLanguage);
    return () => window.removeEventListener('languagechange', updateLanguage);
  }, [language]);

  const value = useMemo(() => ({
    language,
    t: (text) => translations[language]?.[text] || text
  }), [language]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export const useLanguage = () => useContext(LanguageContext);